import React, { useState } from "react";
import { Col, Card, CardBody, Spinner } from "reactstrap";
import { threatCard, threatCardBody } from "./cardStyles";

const hexToRgba = (hex, alpha) => {
  const value = hex.replace("#", "");
  const full = value.length === 3
    ? value.split("").map(ch => ch + ch).join("")
    : value;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const StatsWidget = ({ title, value, subtext, color, icon, loading }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Col xl={2} md={4} sm={6} xs={12} className="flex-fill">
      <Card 
        className="card-animate h-100"
        style={{ 
          ...threatCard,
          transition: 'all 0.3s ease',
          transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
          boxShadow: isHovered ? '0 8px 16px rgba(0,0,0,0.08)' : threatCard.boxShadow,
          cursor: 'pointer',
          minHeight: '140px'
        }}
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <CardBody 
          style={{ 
            display: 'flex', 
            flexDirection: 'column',
            height: '100%',
            ...threatCardBody
          }}
        >
          {/* Title and Icon Row */}
          <div className="d-flex align-items-center justify-content-between mb-2">
            <p 
              className="text-uppercase fw-medium text-muted mb-0" 
              style={{ 
                fontSize: "11px", 
                letterSpacing: "0.5px" 
              }}
            >
              {title}
            </p>
            {icon && (
              (() => {
                const chipBg = color.startsWith("#") ? hexToRgba(color, 0.08) : "rgba(var(--vz-primary-rgb), 0.08)";
                const chipBorder = color.startsWith("#") ? hexToRgba(color, 0.20) : "rgba(var(--vz-primary-rgb), 0.20)";
                return (
              <div style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                border: `1px solid ${chipBorder}`,
                background: chipBg,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                <i className={icon} style={{
                  color,
                  fontSize: 15
                }}></i>
              </div>
                );
              })()
            )}
          </div>

          {/* Value - Center */}
          <div className="flex-grow-1 d-flex align-items-center justify-content-start mt-2">
            {loading ? (
              <Spinner style={{ color: color, width: "2rem", height: "2rem" }} />
            ) : (
              <h4 
                className="fw-semibold mb-0 ff-secondary" 
                style={{ 
                  fontSize: "28px",
                  color: color
                }}
              >
                {typeof value === 'number' ? value.toLocaleString() : value}
              </h4>
            )}
          </div>

          {/* Subtext - Bottom */}
          {subtext && (
            <div className="mt-2">
              <p 
                className="text-muted mb-0" 
                style={{ 
                  fontSize: "12px", 
                  lineHeight: "1.3" 
                }}
              >
                {subtext}
              </p>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default StatsWidget;
